<script setup>
import { pessoasEndpoint } from '@/api/endpoints/pessoas';
import { ref } from 'vue';

const props = defineProps({
    solicitacao: {
        type: Object,
        required: true
    }
})

const urlArquivoPdf = ref('');
const leitorPdfDialogo = ref(false);

const mostrarCarteiraMotorista = (item) => {
    urlArquivoPdf.value = pessoasEndpoint.carteiraMotorista.baixarArquivo(item);
    leitorPdfDialogo.value = true;
};

const expandedRows = ref([]);

</script>

<template>
    <h3 class="text-900 font-bold text-sm mb-3 col-12">Dados da Solicitação</h3>

    <LabelDados v-if="props.solicitacao.dados.justificativa" :titulo="'Justificativa'"
        :conteudo="props.solicitacao.dados.justificativa" tamanho_div="col-12" />

    <hr class="w-full border-solid border-top-1 border-bottom-none surface-border my-3">

    <h3 class="text-900 font-bold text-sm mb-3 col-12">Itens Solicitados</h3>

    <div class="relative w-full" style="contain: inline-size;">
        <TabelaScrollContainer>
            <DataTable v-model:expandedRows="expandedRows" :value="props.solicitacao.dados.items"
                class="transition-linear transition-duration-100 w-full">
                <Column expander style="width: 2rem" :pt="{
                    rowToggler: ({ instance: { rowData } }) => ({
                        class: {
                            'hidden': (rowData.motoristas.length === 0)
                        },
                        style: { width: '12px', height: '12px' }
                    }),
                }">
                </Column>

                <Column header="#" headerStyle="width:35px">
                    <template #body="slotProps">
                        <ColunaListas :titulo="slotProps.index + 1" />
                    </template>
                </Column>

                <Column field="veiculo" header="Veículo" class="text-overflow-ellipsis" style="min-width: 15rem;">
                    <template #body="slotProps">
                        <ColunaListas :titulo="slotProps.data.grupo_veiculo_nome"
                            :descricao="`Retirada em: ${slotProps.data.data_hora_retirada} · Devolução em: ${slotProps.data.data_hora_devolucao}`" />
                    </template>
                </Column>

                <template #expansion="slotProps">
                    <div>
                        <DataTable :value="slotProps.data.motoristas" dataKey="id">
                            <template #empty>
                                <div class="lg:ml-7 py-2 text-sm">
                                    Adicione um Motorista</div>
                            </template>

                            <Column field="pessoa_fisica_nome" header="Motorista"
                                style="width: 20rem; padding-right: 0.2rem;">
                                <template #body="slotProps">
                                    <div class="flex flex-row gap-2 align-items-center">
                                        <ColunaListas :titulo="slotProps.data.pessoa_fisica_nome">
                                            <template #descricao>
                                                <span class="hover:text-800 cursor-pointer" v-tooltip="{
                                                    value: 'Visualizar CNH',
                                                }" @click="mostrarCarteiraMotorista(slotProps.data.pessoa_fisica_id)">Visualizar
                                                    CNH
                                                </span>
                                            </template>
                                        </ColunaListas>
                                    </div>
                                </template>
                            </Column>

                            <Column field="principal" header="Motorista Principal" bodyStyle="text-align: right;"
                                headerStyle="text-align: right;"
                                :pt="{ headerContent: { class: 'justify-content-end' } }">
                                <template #body="slotProps">
                                    <ColunaListas class="align-items-end">
                                        <template #titulo>
                                            <Checkbox :modelValue="slotProps.data.principal" :binary="true" disabled />
                                        </template>
                                    </ColunaListas>
                                </template>
                            </Column>
                        </DataTable>
                    </div>
                </template>
            </DataTable>
        </TabelaScrollContainer>
    </div>

    <DialogoPdf :visible="leitorPdfDialogo" :url-arquivo-pdf="urlArquivoPdf"
        @update:visible="leitorPdfDialogo = $event" />
</template>